import { useState, useEffect, useCallback, useMemo, useRef, Fragment } from "react";
import { Badge, BlockStack, Button, Card, ChoiceList, Collapsible, Icon, IndexFilters, IndexTable, Modal, Page, Popover, Text, Tooltip, useIndexResourceState } from "@shopify/polaris";
import { withRouter } from "react-router";
import KeywordPanelSvg from "./KeywordPanelSvg";
import "../index.scss";
import { AffiliateIcon, ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, DeleteIcon, ViewIcon } from "@shopify/polaris-icons";
import { reqGetTopicClusterDetail, reqDelTopicClusterKeyword, reqJumpOnPageSEO, reqHandleAIUsagePayment, reqGetBlogProgress } from "../../../../api";
import FooterTrustHelp from "../../../../components/FooterTrustHelp";
import { cloneDeep, debounce } from "lodash-es";
import Countrys from '../../../../utils/country';
import SkeltonLoading from "../../../../components/SkeltonLoading";
import Langauge from "../../../../i18n/Language";
import BannerMsgMoudle from "../../../../components/BannerMsgMoudle";
import HighLightText from "../../../../components/HighLightText";
import UnfinishedBlogModal from "../../../../components/UnfinishedBlogModal";
import { store } from "../../../../redux/store";
const t = Langauge;

const ContentPlannerDetail = (props) => {
    let {
        level,
        toggleToast,
        // showEditPageModal,
        openUpdateLimit,
    } = props;

    const detailIdRef = useRef(-1);
    const topicSelArrRef = useRef([]);
    const coveredSelArrRef = useRef([]);
    const kdSelArrRef = useRef([]);
    const listRef = useRef(null);
    const selectedTabRef = useRef(0);
    const jumpBlogIdRef = useRef(-1);
    const topicOriginDataRef = useRef([]);
    const topicClusterIdRef = useRef(-1);

    const [loadingPage, setLoadingPage] = useState(true); // 加载中
    const [loadingTable, setLoadingTable] = useState(true); // 表格加载中
    const [isEmptyData, setIsEmptyData] = useState(false); // 空数据
    const [topicTitle, setTopicTitle] = useState(''); // 话题标题
    const [localObj, setLocalObj] = useState('-'); // 位置
    const [selected, setSelected] = useState(0); // 选中
    const [queryValue, setQueryValue] = useState(""); // 查询值
    const [sortSelected, setSortSelected] = useState(["data asc"]); // 排序
    const [mode, setMode] = useState("DEFAULT"); // DEFAULT || FILTERING 
    const [topicSelArr, setTopicSelArr] = useState([]); // 主题筛选
    const [coveredSelArr, setCoveredSelArr] = useState([]); // 覆盖筛选
    const [kdSelArr, setKdSelArr] = useState([]); // 难度筛选
    const [topicData, setTopicData] = useState([]); // 话题列表数据
    const [topicList, setTopicList] = useState([]); // 话题列表数据 反向
    const [collapsibleIdArr, setCollapsibleIdArr] = useState([]); // 折叠id
    const [selectTopicId, setSelectTopicId] = useState(-1); // 选中话题id
    const [selectItems, setSelectItems] = useState([]); // 选中对象
    const [isPanelExpanded, setIsPanelExpanded] = useState(true); // 脑图是否展开，默认展开
    const [topicCount, setTopicCount] = useState(0); // 话题数量
    const [pagesCount, setPagesCount] = useState(0); // 页面数量
    const [recommendCount, setRecommendCount] = useState(0); // 推荐数量
    const [topicFilters, setTopicFilters] = useState([]); // 话题筛选
    const [showViewId, setShowViewId] = useState(-1); // 显示查看id
    const [delKeywordId, setDelKeywordId] = useState(-1); // 删除关键词id
    const [delKeywordModal, setDelKeywordModal] = useState(-1); // 删除关键词弹窗
    const [messageInfo, setMessageInfo] = useState({}); // 提示信息
    const [userLevel, setUserLevel] = useState(0); // 用户等级
    const [jumpLoading, setJumpLoading] = useState(false); // 跳转加载
    const [aiPoints, setAiPoints] = useState({}); // ai额度
    const [aiUsageStatus, setAiUsageStatus] = useState(-1); // ai使用状态
    // const [aiUse, setAiUse] = useState(0); // ai使用额度
    // const [aiAll, setAiAll] = useState(10); // ai额度
    const [agreeLoading, setAgreeLoading] = useState(false); // 同意loading
    const [buyAiCreditsState, setBuyAiCreditsState] = useState(false); // 超额状态
    const [writeLoading, setWriteLoading] = useState(-1);  // 超额
    const [SERPWidth, setSERPWidth] = useState(0); // SERP宽度
    const [locationId, setLocationId] = useState(2840); // 位置
    const [language, setLanguage] = useState('en'); // 语言
    const [isFirstAiBlogByTopic, setIsFirstAiBlogByTopic] = useState(false); // 是否第一次博客生成
    const [showTipId, setShowTipId] = useState(-1); // 显示提示id
    const [generatingTipState, setGeneratingTipState] = useState(false); // 正在生成提示弹窗
    const [recordData, setRecordData] = useState({}); // 记录数据
    const [recordId, setRecordId] = useState(-1); // 记录ID
    const [businessData, setBusinessData] = useState({}); // 业务数据
    const { selectedResources, allResourcesSelected, handleSelectionChange } =
        useIndexResourceState(topicData);

    // 设置提示banner
    const setTipBanner = (msg, tone = 'critical') => {
        setMessageInfo({ msg, tone });
    }

    // 获取话题详情
    const getTopicClusterDetailFirst = async (id, type = 0) => {
        detailIdRef.current = id;
        const res = await reqGetTopicClusterDetail({ topic_cluster_id: id });
        if (res.ack === 1) {
            let _data = res.data;
            let _list = res.data.list;
            let tkeyData = _list.data;
            let topicNums = tkeyData.length;
            setTopicTitle(_data.topic_cluster?.topic_cluster || '');    // 话题标题
            setLocalObj(Countrys.find(item => item.id === _data.topic_cluster?.location_id)?.name || '-'); // 话题位置
            setLocationId(_data.topic_cluster?.location_id || 2840);
            setLanguage(_data.topic_cluster?.language || 'en');
            let _quota = res.data.ai_points;
            setAiUsageStatus(res.data.ai_usage_status);
            setAiPoints(_quota);
            if (Number(type) === 0) {
                setShowTipId(tkeyData[0]?.pages[0]?.id || -1);
            }
            // setAiUse(_quota.ai_points_gift_use + _quota.ai_points_paid_use);
            // setAiAll(_quota.ai_points_gift_all + _quota.ai_points_paid_all);

            // 判断空
            if (tkeyData.length === 0) {
                setIsEmptyData(true);
            } else {
                setTopicCount(topicNums);    // 话题数量
                setPagesCount(_list.total);     // 页面数量
                setRecommendCount(_list.recommend_total) // 推荐数量
                setSelectTopicId(tkeyData[0]?.id || -1); // 选中话题id
                setSelectItems(tkeyData[0]?.pages || []); // 选中对象
                setCollapsibleIdArr([tkeyData[0]?.pages[0]?.id] || []);
                topicOriginDataRef.current = tkeyData;
                setTopicData(tkeyData);
                setTopicFilters(tkeyData.map(item => ({ label: item.topic, value: item.id }))); // 话题筛选
                // 话题位置
                const topicSiteArr = {
                    "0": { x: 400, y: 400 },    // 默认中心
                    "1": { x: -200, y: 600 },
                    "2": { x: 200, y: 900 },
                    "3": { x: -550, y: 200 },
                    "4": { x: 850, y: 50 },
                    "5": { x: 850, y: 650 },
                    "6": { x: 1350, y: 300 },
                    "7": { x: 1400, y: 800 },
                    "8": { x: -800, y: 650 },
                    "9": { x: 1900, y: 550 },
                    "10": { x: -400, y: 1050 },
                    "11": { x: 800, y: 1200 },
                    "12": { x: -1100, y: 300 },
                    "13": { x: 1350, y: -150 },
                    "14": { x: 1850, y: 100 },
                    "15": { x: 2350, y: 350 },
                    "16": { x: -950, y: 1100 },
                    "17": { x: -1400, y: 800 },
                    "18": { x: 1850, y: 1050 },
                    "19": { x: 450, y: -350 },
                    "20": { x: -1750, y: 400 },
                    "21": { x: 2400, y: 850 },
                    "22": { x: 0, y: 1450 },
                    "23": { x: 2850, y: 550 },
                    "24": { x: -400, y: -350 },
                    "25": { x: -1000, y: -150 },
                    "26": { x: -2000, y: 850 },
                    "27": { x: 1350, y: 1350 },
                    "28": { x: -1600, y: 1200 },
                    "29": { x: -800, y: 1600 },
                }
                // 超出已定义坐标的话题：按索引生成稳定的随机坐标（同一索引刷新后位置固定，测试用）
                const randTopicSite = (i) => {
                    const r = (seed) => { const s = Math.sin(seed) * 10000; return s - Math.floor(s); };
                    return {
                        x: Math.round(-2000 + r(i * 12.9898 + 1) * 4800),  // x ∈ [-2000, 2800]
                        y: Math.round(-600 + r(i * 78.233 + 1) * 2300),    // y ∈ [-600, 1700]
                    };
                };
                // 相关关键词位置
                const subkeywordSiteArr = {
                    "0": { x: 0, y: -185 },         // 默认首个
                    "1": { x: 105, y: -145 },
                    "2": { x: 165, y: -70 },
                    "3": { x: 185, y: 20 },
                    "4": { x: 145, y: 105 },
                    "5": { x: 70, y: 160 },
                }
                // 格式化数据
                let formatData = tkeyData.map((item, index) => {
                    let pillarItem = item.pages.find(i => i.type === 1) || {};
                    let needList = (item.pages.filter(i => i.type !== 1)).slice(0, 6) || [];
                    let subItems = needList.map((son, sindex) => {
                        return {
                            id: `60688${index}${sindex}`,
                            topic_id: item.id,
                            page_id: son.id,
                            title: son.page,
                            position: subkeywordSiteArr[sindex] || { x: 0, y: 0 },
                            cover: Boolean(son.blog_config_id),
                            radius: sindex <= 1 ? 42 : 36,
                            mbShow: sindex <= 2 ? true : false,
                            kd: son.kd,
                            volume: son.volume,
                            keywordsCount: son.keyword_count,
                            isFirst: sindex === 0,
                            blog_config_id: son?.blog_config_id || -1,
                        }
                    });
                    return {
                        id: `44528${index}`,
                        topic_id: item.id,
                        topic_title: item.topic,
                        topic_kd: item.kd,
                        topic_volume: item.volume,
                        pillar_id: pillarItem?.id || -1,
                        active: index === 0,
                        isShowMinCircle: subItems.length > 6 ? true : false,
                        title: pillarItem?.page,
                        position: topicSiteArr[index] || randTopicSite(index),
                        subkeywords: subItems.reverse(),
                        kd: pillarItem?.kd || 0,
                        volume: pillarItem?.volume || 0,
                        keywordsCount: pillarItem?.keywords?.length || 0,
                        isShowSubsText: needList.length > 0,
                        cover: Boolean(pillarItem?.blog_config_id),
                        blog_config_id: pillarItem?.blog_config_id || -1,
                    }
                })
                // 脑图数据
                setTopicList(formatData);
            }
            setLoadingPage(false);
            setLoadingTable(false);
        } else {
            setTipBanner(res.msg);
        }
    }

    // 获取话题详情
    const getTopicClusterDetail = async () => {
        if (detailIdRef.current !== -1) {
            setLoadingTable(true);
            let params = {
                topic_cluster_id: detailIdRef.current,
            }
            if (topicSelArrRef.current.length > 0) {
                params.topic_id = topicSelArrRef.current;
            }
            if (coveredSelArrRef.current.length > 0) {
                params.cover = coveredSelArrRef.current[0] === 'Yes' ? 1 : 0;
            }
            if (kdSelArrRef.current.length > 0) {
                const kdCompare = {
                    1: [70, 100],
                    2: [50, 69],
                    3: [30, 49],
                    4: [0, 29],
                }
                params.kd = [];
                kdSelArrRef.current.forEach((item) => {
                    params.kd.push(kdCompare[item]);
                })
            }
            if (selectedTabRef.current === 1) {
                params.recommend = 1;
            }
            const res = await reqGetTopicClusterDetail(params);
            if (res.ack === 1) {
                let tkeyData = res.data.list.data;
                setRecommendCount(res.data.list?.recommend_total || 0)
                setSelectTopicId(tkeyData[0]?.id || -1);
                setSelectItems(tkeyData[0]?.pages || []);
                setTopicData(tkeyData);
                topicOriginDataRef.current = tkeyData;
            } else {
                setTipBanner(res.msg);
            }
            setLoadingTable(false);
        }
    }

    // 搜索关键词 操作现有列表数据
    const handleSearchKeywordData = (value) => {
        let tData = [];
        let topicOriginData = cloneDeep(topicOriginDataRef.current);
        if (value) {
            let existArr = [];
            topicOriginData.forEach(item => {
                if (item.pages.length > 0) {
                    item.pages.forEach(son => {
                        son.keywords.find(k => (k.keyword.toLowerCase()).includes(value.toLowerCase())) && existArr.push(item.id);
                    })
                }
            })
            let pushIdArr = Array.from(new Set(existArr));
            tData = topicOriginData.filter(item => pushIdArr.includes(item.id));
            // 过滤掉son.keywords里的keyword不包含value的
            tData.forEach(item => {
                item.pages.forEach(son => {
                    son.keywords = son.keywords.filter(k => (k.keyword.toLowerCase()).includes(value.toLowerCase()));
                })
            })
            // 过滤掉pages为空的
            tData.forEach(item => {
                item.pages = item.pages.filter(son => son.keywords.length > 0);
            })
            // 每一个page的id
            let sonIdArr = [];
            tData.forEach(item => {
                if (item.pages.length > 0) {
                    item.pages.forEach(k => sonIdArr.push(k.id));
                }
            })
            setCollapsibleIdArr(sonIdArr);
        } else {
            tData = topicOriginData;
            setCollapsibleIdArr([]);
        }
        setTopicData(tData);
        setSelectTopicId(tData[0]?.id || -1);
        setSelectItems(tData[0]?.pages || []);
    }

    // 获取话题详情 防抖
    const debouncedGetListData = useMemo(() => debounce((value) => {
        handleSearchKeywordData(value);
    }, 300), [handleSearchKeywordData]); // 300ms 可根据需求调整


    // 主题筛选
    const handleTopicChange = (value) => {
        setTopicSelArr(value);
    }
    // 覆盖筛选
    const handleCoveredChange = (value) => {
        setCoveredSelArr(value);
    }
    // 难度筛选
    const handleKDDegreeChange = (value) => {
        setKdSelArr(value);
    }
    // 清除查询
    const handleQueryClear = () => {
        setQueryValue('');
        debouncedGetListData('');
    }
    // 清除主题筛选
    const handleTopicRemove = () => {
        setTopicSelArr([]);
    }
    // 清除覆盖筛选
    const handleCoveredRemove = () => {
        setCoveredSelArr([]);
    }
    // 清除难度筛选
    const handleKDDegreeRemove = () => {
        setKdSelArr([]);
    }

    // 搜索
    const handleFiltersQueryChange = useCallback((value) => {
        setQueryValue(value);
        debouncedGetListData(value);
    }, []);

    // 清除过滤条件
    const handleFiltersClearAll = useCallback(() => {
        handleTopicRemove();
        handleCoveredRemove();
        handleKDDegreeRemove();
        handleQueryClear();
    }, [
        handleTopicRemove,
        handleCoveredRemove,
        handleKDDegreeRemove,
        handleQueryClear,
    ]);

    const onCreateNewView = async (value) => {
        return value;
    };

    // 取消
    const onHandleCancel = () => {
        if (topicSelArr.length > 0 || coveredSelArr.length > 0 || kdSelArr.length > 0 || queryValue !== '') {
            handleFiltersClearAll();
        }
    };

    // 显隐子项
    const toggleColItems = (id) => {
        if (!collapsibleIdArr.includes(id)) {
            let newArr = cloneDeep(collapsibleIdArr);
            newArr.push(id);
            setCollapsibleIdArr(newArr);
        } else {
            let newArr = cloneDeep(collapsibleIdArr);
            newArr.splice(newArr.indexOf(id), 1);
            setCollapsibleIdArr(newArr);
        }
    }

    // 选中话题
    const handleSelectTopic = (ids) => {
        // setCollapsibleIdArr([]);
        let id = Number(ids);
        setSelectTopicId(id);
        setSelectItems(topicData.find(item => Number(item.id) === id)?.pages || []);
        handleCloseGenerateTip();
    }

    // 删除关键词
    const handleOpenDelKeyword = (id) => {
        setDelKeywordModal(id);
    }
    const handleDeleteKeyword = async (id) => {
        setDelKeywordId(id);
        let params = {
            keyword_id: id,
        }
        const res = await reqDelTopicClusterKeyword(params);
        if (res.ack === 1) {
            setDelKeywordModal(-1);
            toggleToast(t("Delete successfully"));
            getTopicClusterDetailFirst(detailIdRef.current);
        } else {
            setTipBanner(res.msg);
        }
        setDelKeywordId(-1);
    }

    // 跳转onpage 博客详情
    const handleJumpOnpageBlog = async (id) => {
        setJumpLoading(true);
        const res = await reqJumpOnPageSEO({ blog_config_id: id });
        if (res.ack === 1) {
            let objs = res.data;
            if (objs?.blog_id === 0) {
                setTipBanner(t("This blog post does not exist or has been removed."));
                setJumpLoading(false);
            } else {
                const _query = {
                    from: 'KeywordContentPlanner',
                    pagetype: 'blog',
                    action: 'article',
                    id: objs.article_id,
                    blog_id: objs.blog_id,
                };
                let path = {
                    pathname: '/on-page-seo/content-edit',
                    query: _query
                }
                props.history.push(path);
            }
        } else {
            setTipBanner(res.msg);
            setJumpLoading(false);
        }
    }

    // 获取生成进度
    const getBlogProgress = async () => {
        const res = await reqGetBlogProgress();
        if (res.ack === 1) {
            let _t = res.data;
            setBusinessData(_t?.business_data || {});
            setRecordData(_t?.record || {});
            setRecordId(_t?.record?.id || -1);
        }
        return res;
    }

    // 跳转ai博客生成页
    const jumpPageUrl = (url, query) => {
        let path = {
            pathname: url,
            query: query
        }
        props.history.push(path);
    }

    // 继续任务
    const handleContinueTask = (id, query = {}) => {
        setWriteLoading(id);
        getBlogProgress().then(res => {
            // 判断状态 跳转
            let url = '/content-seo/ai-blog-generator/generate';
            let _query = {
                type: "selectKeyword",
                language: query.language,
                location: query.location,
                keyword: query.keyword,
                cluster_id: topicClusterIdRef.current,
            };
            if (res.ack === 1) {
                let _t = res.data?.record || {};
                let _business = res.data?.business_data || {};
                if (_t?.status === 0) {
                    _query = {
                        type: "selectKeyword",
                        record_id: _t.id,
                        language: _t.language || _business.content_language,
                        location: _t.location || _business.audience_location,
                        keyword: _t.keyword,
                    }
                } else {
                    _query.language = _business.content_language;
                    _query.location = _business.audience_location;
                }
            }
            setGeneratingTipState(false);
            setWriteLoading(-1);
            jumpPageUrl(url, _query);
        })
    }

    // 直接开始新的任务
    const handleGeneratingNew = () => {
        let url = '/content-seo/ai-blog-generator/generate';
        let _id = jumpBlogIdRef.current;
        const objs = selectItems.find(item => item.id === _id);
        let _query = {
            type: "selectKeyword",
            keyword: objs?.page || "",
            language: businessData.content_language,
            location: businessData.audience_location,
            cluster_id: topicClusterIdRef.current,
        }
        setGeneratingTipState(false);
        jumpPageUrl(url, _query);
    }

    // 跳转创建博客
    const jumpCreateBlog = (id, isJump = false) => {
        handleCloseGenerateTip();
        jumpBlogIdRef.current = id;
        const objs = selectItems.find(item => item.id === id);
        // const topicSel = topicData.find(item => item.id === selectTopicId);
        let _abb = Countrys.find(item => item.id === locationId)?.abb || 'US';
        let _query = {
            type: "selectKeyword",
            keyword: objs?.page || "",
            language: language,
            location: _abb,
            // jumptype: 'keywords-planner',
            // topicId: selectTopicId,
            // keyword: objs?.page || "",
            // relatedKeyword: objs?.keywords || [],
            // aiIns: objs?.page_strategy || "",
            // topic_select: topicSel,
            // topic_list: topicData,
            // location_id: locationId,
        }
        // 判断额度
        let _ai = aiPoints, _aiStatus = aiUsageStatus;
        let g_use = _ai.ai_points_gift_use;
        let g_all = _ai.ai_points_gift_all;
        let p_use = _ai.ai_points_paid_use;
        let p_all = _ai.ai_points_paid_all;
        if (((g_all - g_use < 20) && (p_all - p_use < 20)) && !isJump) {
            if (userLevel !== 1 && [30002, 30003, 40002].includes(_aiStatus)) {
                // 判断是否达到上限
                if ([40002].includes(_aiStatus)) {
                    openUpdateLimit();
                } else {
                    props.openOverageModal({ type: 'points', points: 20, onSuccess: () => jumpCreateBlog(jumpBlogIdRef.current, true) });
                }
            } else if (_aiStatus === true) {
                setWriteLoading(id);
                handleOverchargeState(true, 20);
            } else if (userLevel === 3) {
                handleBuyAiCreditsState(true);
            } else {
                props.upgradeModal(userLevel < 2 ? 1 : 2, 'KeywordPlanner', 'content_planner_detail', true);
            }
        } else {
            // shopify 内嵌模式
            // const isShopify = window.shopify;
            // const url = "/content-seo/ai-blog-generator/generate";
            // if (isShopify) {
            //     showEditPageModal(url, "OnpageBlog_Modal", null, _query);
            // } else {
            // }
            // let path = {
            //     pathname: url,
            //     query: _query
            // }
            // props.history.push(path);
            if (recordData?.status === 0) {
                setGeneratingTipState(true);
            } else {
                handleContinueTask(id, _query);
            }
        }
    }

    // 超额扣费（AI 积分直充：_aiStatus === true 场景）
    const handleOverchargeState = async (state, defalutPoints = 0) => {
        setAgreeLoading(true);
        let params = {
            points: defalutPoints > 0 ? defalutPoints : 20
        }
        const res = await reqHandleAIUsagePayment(params);
        if (res.ack === 1) {
            // 执行跳转
            jumpCreateBlog(jumpBlogIdRef.current, true);
        } else {
            toggleToast(res.msg, true);
            setWriteLoading(-1);
        }
        setAgreeLoading(false);
    }

    // 购买积分提示
    const handleBuyAiCreditsState = (_state) => {
        setBuyAiCreditsState(_state);
    }

    // 查看对应page
    const handleViewPageItem = (topicId, id) => {
        if (selectTopicId !== topicId) {
            handleSelectTopic(topicId);
        }
        // 打开对应page
        if (id !== -1) {
            setCollapsibleIdArr([id]);
        }
        const parent = document.getElementById('keyword_planner_list');
        if (parent) {
            setTimeout(() => {
                parent.scrollIntoView({
                    behavior: 'smooth',  // 平滑滚动
                    block: 'start'       // 滚动到元素顶部对齐
                });
            }, 10)
        }
    }

    // 生成博客
    const handleGenerateBlog = (id) => {
        jumpCreateBlog(id, false);
    }

    // 查看博客
    const handleViewBlog = (id) => {
        handleJumpOnpageBlog(id);
    }

    // 返回
    const goBack = () => {
        props.history.push({
            pathname: "/content-seo/keyword-content-planner",
        });
    }

    // 过滤条件    
    const CoveredFilters = [
        { label: t("Yes"), value: 'Yes' },
        { label: t("No"), value: 'No' },
    ]
    const KdDegreeFilters = [
        { label: t("Very hard (70-100)"), value: 1 },
        { label: t("Difficult (50-69)"), value: 2 },
        { label: t("Possible (30-49)"), value: 3 },
        { label: t("Easy (0-29)"), value: 4 },
    ]
    const filters = [
        {
            key: 'Topic',
            label: t("Topic"),
            filter: (
                <ChoiceList
                    title={t("Topic")}
                    titleHidden
                    choices={topicFilters}
                    selected={topicSelArr || []}
                    onChange={handleTopicChange}
                    allowMultiple
                />
            ),
            pinned: true,
        },
        {
            key: 'Covered',
            label: t("Covered"),
            filter: (
                <ChoiceList
                    title={t("Covered")}
                    titleHidden
                    choices={CoveredFilters}
                    selected={coveredSelArr || []}
                    onChange={handleCoveredChange}
                />
            ),
            pinned: true,
        },
        {
            key: 'KdDegree',
            label: t("KD"),
            filter: (
                <ChoiceList
                    title={t("KD")}
                    titleHidden
                    choices={KdDegreeFilters}
                    selected={kdSelArr || []}
                    onChange={handleKDDegreeChange}
                    allowMultiple
                />
            ),
            pinned: true,
        }
    ];
    const appliedFilters = [];
    if (topicSelArr && !isEmpty(topicSelArr)) {
        const key = 'Topic';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, topicSelArr, topicFilters),
            onRemove: handleTopicRemove,
        })
    }
    if (coveredSelArr && !isEmpty(coveredSelArr)) {
        const key = 'Covered';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, coveredSelArr, CoveredFilters),
            onRemove: handleCoveredRemove,
        })
    }
    if (kdSelArr && !isEmpty(kdSelArr)) {
        const key = 'KdDegree';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, kdSelArr, KdDegreeFilters),
            onRemove: handleKDDegreeRemove,
        })
    }

    // 监听点击
    const handleCloseGenerateTip = () => {
        if (isFirstAiBlogByTopic) {
            props.requestStateSet("is_first_ai_blog_by_topic", 1);
        }
        setShowTipId(-1);
        setIsFirstAiBlogByTopic(false);
    };

    // 监听选中话题id，更改右侧表格
    useEffect(() => {
        let allTr = document.querySelectorAll(`tr[id*="topic"]`);
        allTr.forEach(item => {
            if (item.id === `topic-${selectTopicId}`) {
                item.setAttribute('data-bg-color', 'true');
            } else {
                item.removeAttribute('data-bg-color');
            }
        })
    }, [selectTopicId])

    // 监听切换id，更改右侧表格
    useEffect(() => {
        let allTr = document.querySelectorAll(`tr[id*="pillar"]`);
        allTr.forEach(item => {
            let firstChild = item.querySelector('td');
            if (item.id === `pillar-${collapsibleIdArr[0]}`) {
                // 添加data-bg-color
                item.setAttribute('data-bg-color', 'true');
                // 第一个子元素也要添加data-bg-color
                firstChild.setAttribute('data-bg-color', 'true');
            } else {
                // 移除data-bg-color
                item.removeAttribute('data-bg-color');
                firstChild.removeAttribute('data-bg-color');
            }
        })
    }, [collapsibleIdArr])

    // 筛选条件更新列表
    useEffect(() => {
        topicSelArrRef.current = topicSelArr;
        coveredSelArrRef.current = coveredSelArr;
        kdSelArrRef.current = kdSelArr;
        selectedTabRef.current = selected;
        getTopicClusterDetail();
    }, [topicSelArr, coveredSelArr, kdSelArr, selected])

    // 监听触摸行
    useEffect(() => {
        const parent = listRef.current;
        if (!parent) return;
        let lastHoverId = null;
        setSERPWidth(listRef.current.offsetWidth);  // 设置SERP宽度
        const handleMouseOver = (e) => {
            const row = e.target.closest(".Polaris-IndexTable__TableRow");
            if (!row || !parent.contains(row)) return;
            const trClss = e.target.closest("tr")?.id || '';
            const lastObj = trClss ? Number(trClss.split('-')[1]) : '';
            if (lastObj && lastObj !== lastHoverId && !Boolean(e.target.parentElement?.id.includes('SERP'))) {
                lastHoverId = Number(lastObj);
                setShowViewId(lastHoverId);
            }
        };

        const handleMouseOut = (e) => {
            const row = e.target.closest(".Polaris-IndexTable__TableRow");
            if (!row || !parent.contains(row)) return;
            lastHoverId = null;
            setShowViewId(-1);
        };

        parent.addEventListener("mouseover", handleMouseOver);
        parent.addEventListener("mouseout", handleMouseOut);

        return () => {
            parent.removeEventListener("mouseover", handleMouseOver);
            parent.removeEventListener("mouseout", handleMouseOut);
        };
    }, [selectItems]);

    useEffect(() => {
        setUserLevel(level);
    }, [level])

    useEffect(() => {
        let _query = new URLSearchParams(props.location.search);
        let topicId = _query.get('tc_id') || -1;
        let topicType = _query.get('tc_type') || 0;
        if (topicId !== -1) {
            topicClusterIdRef.current = topicId;
            getTopicClusterDetailFirst(topicId, topicType);
        } else {
            // 默认空
            setIsEmptyData(true);
            setLoadingPage(false);
        }

        // 监听记录数据
        getBlogProgress();

        store.subscribe(() => {
            let _switchData = store.getState().public.publicInit?.head_data?.switch_data;
            let isFirstAiBlogByTopic = typeof _switchData === 'boolean' ? true : Boolean(_switchData?.is_first_ai_blog_by_topic && _switchData?.is_first_ai_blog_by_topic?.st === 0);
            setIsFirstAiBlogByTopic(isFirstAiBlogByTopic);
        })

        // 监听表格宽度
        if (!listRef.current) return;
        // 创建 ResizeObserver
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                // 获取表格宽度
                setSERPWidth(entry.contentRect.width);
            }
        });
        resizeObserver.observe(listRef.current);

        // 组件卸载时清理
        return () => {
            resizeObserver.disconnect();
        };
    }, [])

    // 删除提示弹窗
    const deleteTipModal = <Modal
        size="small"
        open={Boolean(delKeywordModal !== -1)}
        onClose={() => setDelKeywordModal(-1)}
        title={t("Confirm Deletion")}
        primaryAction={{
            content: t("Delete"),
            onAction: () => handleDeleteKeyword(delKeywordModal),
            loading: delKeywordId === delKeywordModal
        }}
        secondaryActions={[
            {
                content: t("Keep"),
                onAction: () => setDelKeywordModal(-1)
            }
        ]}
    >
        <Modal.Section>
            <p>{t("Once deleted, this cannot be restored. Do you want to continue?")}</p>
        </Modal.Section>
    </Modal>

    // 正在生成提示弹窗
    const generatingTipModal = <UnfinishedBlogModal
        open={generatingTipState}
        loading={writeLoading !== -1}
        onStartNew={handleGeneratingNew}
        onContinue={() => handleContinueTask(jumpBlogIdRef.current, {})}
        onClose={() => setGeneratingTipState(false)}
        toggleToast={toggleToast}
        recordId={recordId}
    />

    // 积分不足提示
    const creditsBuyModal = <Modal
        open={buyAiCreditsState}
        title={t("AI Credit Reminder")}
        primaryAction={{
            content: t("Purchase AI Credits"),
            onAction: () => props.history.push({
                pathname: "/plan",
                query: "pay_credits"
            })
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleBuyAiCreditsState(false)
            }
        ]}
        onClose={() => handleBuyAiCreditsState(false)}
    >
        <Modal.Section>
            <p>{t("Your AI credit balance is insufficient")}</p>
        </Modal.Section>
    </Modal>


    // 表格 - topic
    const rowMarkupTopic = topicData.map(
        (
            { id, topic, kd, volume },
            index,
        ) => (
            <IndexTable.Row
                id={`topic-${id}`}
                key={topic}
                selected={selectedResources.includes(id)}
                position={index}
                onClick={() => handleSelectTopic(id)}
            >
                <IndexTable.Cell>
                    <Tooltip content={<div className="flex_layout">
                        <span>Vol: {formatNumber(volume)}</span>
                        <span>KD: {kd}</span>
                    </div>}>
                        <Text variant="bodyMd" fontWeight="bold" as="span">
                            <div className="table_text topic_item">{topic}</div>
                        </Text>
                    </Tooltip>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );
    const rowMarkupPage = selectItems.map(
        (
            { id, page, type, kd, volume, keyword_count, keywords, page_strategy, blog_config_id },
            index,
        ) => (
            <Fragment key={`${index}-${id}`}>
                <IndexTable.Row
                    rowType="data"
                    id={`pillar-${id}`}
                    selected={selectedResources.includes(id)}
                    position={index}
                >
                    <IndexTable.Cell>
                        <div className="flex_layout" style={{ gap: "0.5em" }}>
                            <Button variant="tertiary" onClick={(e) => {
                                e && e.stopPropagation();
                                toggleColItems(id);
                            }} icon={collapsibleIdArr.includes(id) ? ChevronDownIcon : ChevronRightIcon}></Button>
                            <Text variant="bodyMd" fontWeight="bold" as="span">
                                <div className="page_item">{page}</div>
                            </Text>
                            {type === 1 && <Badge tone="success">{t("Pillar page")}</Badge>}
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <Badge tone={kd <= 29 ? 'success' : kd <= 49 ? 'attention' : kd <= 69 ? 'warning' : 'critical'}>{`${kd}`}</Badge>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div style={{ textAlign: "center" }}>
                            {formatNumber(volume)}
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div style={{ textAlign: "center" }}>
                            {formatNumber(keyword_count)}
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div style={{ textAlign: "center" }}>
                            {
                                !Boolean(blog_config_id) ? <Popover
                                    active={showTipId === id && isFirstAiBlogByTopic}
                                    activator={
                                        <Button variant="primary" loading={writeLoading === id} disabled={agreeLoading || writeLoading !== -1} onClick={() => jumpCreateBlog(id, false)}>{t("Create Blog")}</Button>
                                    }
                                    onClose={handleCloseGenerateTip}
                                >
                                    <div className="create_blog_popover_content">
                                        <p>{t("Generate a blog for this page.")}</p>
                                        <img src="/imgs/ai/plannerAiTip.png" alt="" />
                                    </div>
                                </Popover> : <Tooltip content={t("View the blog post")}>
                                    <Button icon={ViewIcon} loading={jumpLoading} onClick={() => handleJumpOnpageBlog(blog_config_id)}>{t("View")}</Button>
                                </Tooltip>
                            }
                        </div>
                    </IndexTable.Cell>
                </IndexTable.Row>
                {/* 下拉详情行 */}
                {
                    collapsibleIdArr.includes(id) ? <IndexTable.Row
                        rowType="child"
                        id={`SERP-${id}`}
                        selected={selectedResources.includes(id)}
                        position={index}
                    >
                        <IndexTable.Cell>
                            <div className="serp-tip-box">
                                <div className="serp-content" style={{ width: `${SERPWidth - (window.innerWidth < 768 ? 250 : 64)}px` }}>
                                    <Text variant="bodyMd" fontWeight="bold" as="span">{t("Content Suggestions")}</Text>
                                    <p className="Every_Card_Desc ellipsis_3" title={page_strategy}>{page_strategy}</p>
                                </div>
                            </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell></IndexTable.Cell>
                        <IndexTable.Cell></IndexTable.Cell>
                        <IndexTable.Cell></IndexTable.Cell>
                        <IndexTable.Cell></IndexTable.Cell>
                    </IndexTable.Row> : null
                }
                {
                    collapsibleIdArr.includes(id) ? keywords.map(son => {
                        return (
                            <IndexTable.Row
                                rowType="child"
                                id={`${index}-${son.id}`}
                                key={`${index}-${son.id}`}
                                selected={selectedResources.includes(son.keyword)}
                                position={index}
                            >
                                <IndexTable.Cell>
                                    <div className="flex_layout">
                                        {
                                            queryValue ? <HighLightText text={son.keyword} keyword={queryValue} style={{ backgroundColor: '#f19b4a' }} /> :
                                                <Text variant="bodyMd" as="span">
                                                    {son.keyword}
                                                </Text>
                                        }
                                    </div>
                                </IndexTable.Cell>
                                <IndexTable.Cell>
                                    <Badge tone={son.kd <= 29 ? 'success' : son.kd <= 49 ? 'attention' : son.kd <= 69 ? 'warning' : 'critical'}>{`${son.kd}`}</Badge>
                                </IndexTable.Cell>
                                <IndexTable.Cell>
                                    <div style={{ textAlign: "center" }}>
                                        {formatNumber(son.volume)}
                                    </div>
                                </IndexTable.Cell>
                                <IndexTable.Cell></IndexTable.Cell>
                                <IndexTable.Cell>
                                    <div style={{ opacity: (showViewId === Number(son.id) || delKeywordId === son.id) ? 1 : 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Button variant="tertiary" icon={DeleteIcon} onClick={() => handleOpenDelKeyword(son.id)} loading={delKeywordId === son.id}></Button>
                                    </div>
                                </IndexTable.Cell>
                            </IndexTable.Row>
                        );
                    }) : null
                }
            </Fragment>
        ),
    );

    // 关键词规划列表模块
    const keywordListModule = <div id="keyword_planner_list" className="keyword_planner_list_module">
        <Card padding={0}>
            <IndexFilters
                sortOptions={false}
                sortSelected={sortSelected}
                queryValue={queryValue}
                queryPlaceholder={t("Search keywords")}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={() => handleQueryClear()}
                onSort={setSortSelected}
                primaryAction={false}
                cancelAction={{
                    onAction: onHandleCancel,
                    disabled: false,
                    loading: false,
                }}
                tabs={
                    mode === "DEFAULT" ? [
                        {
                            id: "All",
                            content: <div className="flex_layout">
                                <span>{t("All")}</span>
                                {
                                    Boolean(pagesCount) && <Badge>{pagesCount}</Badge>
                                }
                            </div>,
                        },
                        {
                            id: "Recommendation",
                            content: <div className="flex_layout">
                                <span>{t("Recommendation")}</span>
                                {
                                    Boolean(recommendCount) && <Badge>{recommendCount}</Badge>
                                }
                            </div>,
                        }
                    ] : []
                }
                selected={selected}
                onSelect={setSelected}
                canCreateNewView={false}
                onCreateNewView={onCreateNewView}
                filters={filters}
                appliedFilters={appliedFilters}
                onClearAll={handleFiltersClearAll}
                mode={mode}
                setMode={setMode}

            />
            {
                topicData.length > 0 ?
                    <div className="planner_detail_table flex_layout">
                        <div className="left_table">
                            <IndexTable
                                resourceName={{
                                    singular: t("data"),
                                    plural: t("data"),
                                }}
                                itemCount={topicData.length}
                                selectedItemsCount={
                                    allResourcesSelected ? 'All' : selectedResources.length
                                }
                                onSelectionChange={handleSelectionChange}
                                headings={[
                                    { title: t("Topic") },
                                ]}
                                selectable={false}
                                loading={loadingTable}
                            >
                                {rowMarkupTopic}
                            </IndexTable>
                        </div>
                        <div className="right_table" ref={listRef}>
                            <IndexTable
                                resourceName={{
                                    singular: t("data"),
                                    plural: t("data"),
                                }}
                                itemCount={selectItems.length}
                                selectedItemsCount={
                                    allResourcesSelected ? 'All' : selectedResources.length
                                }
                                onSelectionChange={handleSelectionChange}
                                headings={[
                                    { title: t("Page") },
                                    { title: t("KD") },
                                    { title: t("Volume"), alignment: "center" },
                                    { title: t("Keyword Count"), alignment: "center" },
                                    { title: t("Action"), alignment: "center" },
                                ]}
                                selectable={false}
                            >
                                {rowMarkupPage}
                            </IndexTable>
                        </div>
                    </div> :
                    <IndexTable
                        resourceName={{
                            singular: t("data"),
                            plural: t("data"),
                        }}
                        itemCount={0}
                        selectedItemsCount={
                            allResourcesSelected ? 'All' : selectedResources.length
                        }
                        onSelectionChange={() => { }}
                        headings={[]}
                        selectable={false}
                    ></IndexTable>
            }
        </Card>
    </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终页面内容
    const pageContent = loadingPage ? <SkeltonLoading /> : (!isEmptyData ? <BlockStack gap={400}>
        <BannerMsgMoudle MessageInfo={messageInfo} toggleToast={toggleToast} callbackCloseBanner={() => setMessageInfo({})} />

        {/* 集群脑图 */}
        <div className="planner-main">
            {/* 标头 */}
            <div className={`planner-header${isPanelExpanded ? '' : ' collapsed'}`}>
                <div className="planner-header-title flex_layout">
                    <div className="flex_layout">
                        <Icon source={AffiliateIcon} tone="base" />
                        <Text variant="headingMd" as="h2">{t("Topical Overview")}</Text>
                    </div>
                    <span className="Every_Card_Desc">{t("{{v1}} topics, {{v2}} pages", topicCount, pagesCount)}</span>
                </div>
                <Button
                    icon={isPanelExpanded ? ChevronUpIcon : ChevronDownIcon}
                    onClick={() => setIsPanelExpanded(v => !v)}
                    accessibilityLabel={isPanelExpanded ? t("Collapse") : t("Expand")}
                />
            </div>
            <Collapsible
                open={isPanelExpanded}
                id="planner-panel-collapsible"
                transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
            >
                <KeywordPanelSvg
                    topicList={topicList}
                    jumpLoading={jumpLoading}
                    handleViewPageItem={handleViewPageItem}
                    handleGenerateBlog={handleGenerateBlog}
                    handleViewBlog={handleViewBlog}
                />
            </Collapsible>
        </div>

        {keywordListModule}
        {FooterHelpBox}
    </BlockStack> : <Card>
        <div className="empty_content">
            <img src="/imgs/ai/keyword_planner.png" alt="keyword_planner" />
            <BlockStack gap={100}>
                <Text variant="headingLg" as="h2">{t("No Results for This Keyword")}</Text>
                <p className="Every_Card_Desc">{t("No data found for this keyword. Please try entering a general seed keyword.")}</p>
            </BlockStack>
            <Button variant="primary" onClick={() => goBack()}>{t("Generate New")}</Button>
        </div>
    </Card>)

    return (
        loadingPage ? <SkeltonLoading /> : <Page
            fullWidth={true}
            title={topicTitle}
            subtitle={`${t("Location")}: ${localObj}`}
            backAction={{
                content: "Back",
                onAction: () => {
                    goBack();
                }
            }}
        >
            <title>SEOWILL - Keyword Content Planner Detail</title>

            <div className="content_planner_page">
                {pageContent}
                {deleteTipModal}
                {creditsBuyModal}
                {generatingTipModal}
            </div>
        </Page>
    );
};

function disambiguateLabel(key, selectVal, arr) {
    if (selectVal.length === 0) return key;
    switch (key) {
        case 'Topic':
            let topicArr = arr.filter(i => selectVal.includes(i.value));
            let topicText = '';
            topicArr.forEach((t, i) => {
                topicText += i === topicArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Topic: ${topicText}`;
        case 'Covered':
            return `${t("Covered")}: ${t(selectVal[0])}`;
        case 'KdDegree':
            let kdArr = arr.filter(i => selectVal.includes(i.value));
            let kdText = '';
            kdArr.forEach((t, i) => {
                kdText += i === kdArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `KD: ${kdText}`;
        default:
            return selectVal;
    }
}

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

// 单位转换
function formatNumber(num) {
    // 将数字转换为以K为单位
    return (typeof num === 'number' && !isNaN(num) && num >= 1000) ? (num / 1000).toFixed(1) + 'K' : num;
}

export default withRouter(ContentPlannerDetail);